<template>
  <div class="pa-0 secondary--text text--darken-3">
    <div class="bg-grey-light pa-8 border-bottom">
      <div class="caption primary--text font-weight-black text-uppercase tracking-widest mb-4 d-flex align-center">
        <v-icon x-small color="primary" class="mr-2">fas fa-layer-group</v-icon> Productos Seleccionados
      </div>
      
      <v-card outlined class="modern-card elevation-0 overflow-hidden mb-8">
        <v-simple-table dense class="modern-simple-table">
          <thead class="bg-white">
            <tr>
              <th class="text-uppercase tracking-wider caption font-weight-black">SKU</th>
              <th class="text-uppercase tracking-wider caption font-weight-black">Producto</th>
              <th class="text-uppercase tracking-wider caption font-weight-black">OT</th>
              <th class="text-uppercase tracking-wider caption font-weight-black">Etapa Actual</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" :key="product.id">
              <td class="caption font-weight-bold grey--text">{{ product.library_product__sku }}</td>
              <td class="body-2 font-weight-bold">{{ product.name }}</td>
              <td class="body-2 primary--text font-weight-black">#{{ product.work_order__id }}</td>
              <td>
                <v-chip
                  size="small"
                  :color="product.prestage ? product.prestage.color : 'primary'"
                  label
                  outlined
                  x-small
                  class="font-weight-black text-uppercase shadow-xs"
                >
                  {{ product.prestage ? product.prestage.name : 'N/A' }}
                </v-chip>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>

      <div class="caption primary--text font-weight-black text-uppercase tracking-widest mb-4 d-flex align-center">
        <v-icon x-small color="primary" class="mr-2">fas fa-exchange-alt</v-icon> Especificar Nueva Etapa
      </div>

      <ValidationObserver v-slot="{ handleSubmit }">
        <v-form @submit.prevent="handleSubmit(confirmation)">
          <v-row dense>
            <v-col cols="12">
              <ValidationProvider name="Nueva Etapa" rules="required" v-slot="{ errors }">
                <v-select
                  v-model="prestage_id"
                  :items="stages"
                  label="Seleccione la etapa de destino"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  class="modern-input bg-white"
                  :error-messages="errors"
                  prepend-inner-icon="fas fa-route"
                >
                  <template v-slot:item="{ item }">
                    <div class="d-flex align-center py-1 w-full">
                      <v-avatar :color="item.color || 'primary'" size="24" class="mr-3 shadow-xs">
                        <span class="white--text caption font-weight-black">{{ item.sort || '•' }}</span>
                      </v-avatar>
                      <span class="body-2 font-weight-bold">{{ item.name }}</span>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <div class="d-flex mt-6 gap-3">
            <v-btn 
              type="submit" 
              color="primary" 
              large 
              depressed 
              :loading="loading"
              class="flex-grow-1 py-6 rounded-lg font-weight-black text-uppercase tracking-widest shadow-md"
            >
              <v-icon small class="mr-2">fas fa-save</v-icon>
              Actualizar Flujo
            </v-btn>
            <v-btn 
              text 
              large 
              color="grey darken-1"
              class="rounded-lg font-weight-bold px-8"
              @click.prevent="cancel"
            >
              Cancelar
            </v-btn>
          </div>
        </v-form>
      </ValidationObserver>
    </div>

    <confirm
      v-model="showProductToProduction" 
      message="¿Confirma pasar estos productos a Producción? El flujo de pre-prensa se dará por finalizado."
      @ok="save(false)"
      @cancel="showProductToProduction = false"
    />
  </div>
</template>

<script>
import { updateProductionProduct } from '@/api/production'
import notifications from '@/utils/notifications'

export default {
  name: 'ChangePrestage',
  props: ['products'],
  data() {
    return {
      loading: false,
      stages: [],
      prestage_id: '',
      showProductToProduction: false
    }
  },
  methods: {
    confirmation() {
      if (this.prestage_id < 0) this.showProductToProduction = true
      else this.save(true)
    },
    async save(in_prestage) {
      this.showProductToProduction = false
      this.loading = true
      
      const payload = in_prestage 
        ? { in_prestage: true, prestage_id: this.prestage_id }
        : { in_prestage: false }

      try {
        for (const product of this.products) {
          await updateProductionProduct(product.id, payload)
        }
        notifications.showSuccess('Flujo actualizado correctamente')
        this.clearAndClose()
        this.$emit('updated')
      } catch (e) {
        notifications.showError('Error al actualizar: ' + e.message)
      } finally {
        this.loading = false
      }
    },
    cancel() {
      this.clearAndClose()
    },
    clearAndClose() {
      this.prestage_id = ''
      this.$emit('close')
    }
  },
  mounted() {
    this.stages = [...this.$store.getters.getStages.filter(s => s.enabled !== false), { id: -1, name: 'Producción', color: 'success' }]
  }
}
</script>

<style scoped>
.modern-card { border: 1px solid rgba(0,0,0,0.08) !important; border-radius: 12px !important; background-color: #fff; }
.modern-simple-table { background: transparent !important; }
.modern-simple-table th { height: 44px !important; border-bottom: 2px solid rgba(0,0,0,0.03) !important; }
.modern-simple-table td { height: 48px !important; border-bottom: 1px solid rgba(0,0,0,0.02) !important; }
.bg-grey-light { background-color: #f8f9fa; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.08); }
.shadow-md { box-shadow: 0 4px 12px rgba(var(--v-primary-base), 0.2) !important; }
.shadow-xs { box-shadow: 0 1px 2px rgba(0,0,0,0.03) !important; }
.tracking-widest { letter-spacing: 2px; }
.tracking-wider { letter-spacing: 1px; }
.gap-3 { gap: 12px; }
.w-full { width: 100%; }

.modern-input >>> .v-input__control { min-height: 48px !important; }
.modern-input >>> fieldset { border: 1px solid rgba(0,0,0,0.1) !important; border-radius: 8px !important; }
.modern-input >>> .v-input__prepend-inner { margin-top: 12px !important; margin-right: 12px !important; }
</style>